/* eslint-disable */
import _ from 'underscore';
import backbone from 'backbone';
import odata from '@bingads-webui-static-legacy/communication/channel/odata';
import * as urlUtil from '@bingads-webui/url-util';
var Collection = backbone.Collection.extend({
  url: 'Advertiser/Customers()/Accounts?$orderby=Name&$select=Id,Name,Status,AccountNumber',
  model: null,
  sync: function (method, model, options) {
    var today = new Date();
    var yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    var start = {
      startdate: yesterday.toISOString().slice(0, 10)
    };
    var end = {
      enddate: today.toISOString().slice(0, 10)
    };
    this.url = urlUtil.queryify(this.url, start);
    this.url = urlUtil.queryify(this.url, end);
    if (method === 'read') {
      return odata.get(this.url, null, options);
    }
  }
});
export default Collection;

